<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href=route_back>Репозитории</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Добавить репозиторий</li>
        </ol>
    </nav>

    <div class="inform col-md-4 col-12">
        <div class="form-row">
            <div class="col-md-12">
                <label for="input_name_client_id">Клиент</label>
                <select id="input_name_client_id" v-model="picked_client" class="form-select">
                    <option disabled value="0">-------</option>
                    <option v-for="client in clients" :value="client.id">{{ client.name }}</option>
                </select>
            </div>
        </div>

        <div class="form-row">
            <div class="col-md-12">
                <label for="input_name_brand_id">Бренд</label>
                <select id="input_name_brand_id" v-model="formData.brand_id" class="form-select">
                    <option disabled value="0">-------</option>
                    <option v-for="brand in brands" :value="brand.id">{{ brand.name }}</option>
                </select>
            </div>
        </div>

        <div class="form-row">
            <div class="col-md-12">
                <label for="repos-type_id">Тип репозитория</label>
                <input type="text" class="form-control" id="repos-type_id" v-model="formData.type_id" placeholder="Введите тип репозитория">
            </div>
        </div>

        <div class="form-row">
            <div class="col-md-12">
                <label for="repos-repository_path">Ссылка на репозиторий</label>
                <input type="text" class="form-control" id="repos-repository_path" v-model="formData.repository_path" placeholder="Введите ссылку на репозиторий">
            </div>
        </div>

        <div class="form-row">
            <div class="col-md-12">
                <label for="repos-repository_login">Логин репозитория</label>
                <input type="text" class="form-control" id="repos-repository_login" v-model="formData.repository_login" placeholder="Введите логин репозитория">
            </div>
        </div>

        <div class="form-row">
            <div class="col-md-12">
                <label for="repos-repository_login">Пароль репозитория</label>
                <input type="text" class="form-control" id="repos-repository_login" v-model="formData.repository_login" placeholder="Введите пароль репозитория">
            </div>
        </div>

        <div class="d-flex w-50 align-items-center justify-content-start">
            <button class="btn btn-lg btn-primary me-3" v-on:click="createRepository()">
                Добавить
            </button>

            <a class="btn btn-lg btn-outline-dark" :href="route_back">Отменить</a>
        </div>
    </div>
</template>

<script>
import Repository from "../../../../models/Repository";

export default {
    name: "RepositoryCreateComponent",
    props: {
        route_back: String,
        route_client_search: String,
        route_brand_search: String,
        route_create: String
    },
    data: function () {
       return {
           repository: new Repository({
               route_create: this.route_create,
               route_brand_search: this.route_brand_search,
               route_client_search: this.route_client_search
           }),
           clients: [],
           brands: [],
           picked_client: 0,
           formData: {
               client_id: 0,
               brand_id: 0,
               type_id: 0,
               repository_path: '',
               repository_login: '',
               repository_password: ''
           }
       }
    },
    watch: {
        picked_client: function () {
            this.formData.client_id = this.picked_client;
            this.searchBrands();
        }
    },
    methods: {
        createRepository: async function () {
            let result = await this.repository.create(this.formData);
            if(result)
            {
                window.location.href = this.route_back;
            }
            else
            {
                console.log('error: create_repository');
            }
        },
        searchClients: async function () {
            let clients = await this.repository.clients();
            this.clients = clients.items;
        },
        searchBrands: async function () {
            let brands = await this.repository.brands({
                client_id: this.formData.client_id
            });
            this.brands = brands.items;
        },
    },
    mounted() {
        this.searchClients();
        this.searchBrands();
    }
}
</script>

<style scoped>

</style>
